import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { IInquiryCndsState, IPjt0105MState, IExtUserItemState, IExtUserListItemState, IBelongDcdState, IPostCdState } from '../../models/pjt/pjt0105m_model';

const initialState: IPjt0105MState = {

    extUserData: {
        id: 0,
        userNm: "",
        extEmpNo: "",
        userEmail: "", // 이메일
        mobileNo: "", // 전화번호
        postCd: "", // 직위코드
        pid: dayjs().format('YYYYMMDD'),   // 생년월일
        gndrTpCd: "", // 성별
        belongDcd: "", // 소속코드
        delYn: "N",
    },        // 외부직원(등록정보)

    extUserList: [],  // 외부직원목록(조회결과)
    belongDcdList: [],        // 소속 코드
    postCdList: [],        // 부서상태구분코드

    /* 조회조건 */
    inquiryCnds: {
        userNm: "", // 사용자 이름
        belongDcd: "",
        extEmpNo: "",
    },

    pageSize: 20,     // 페이징건수
    current: 0,
}

export const pjt0105m_Slice = createSlice({
    name: "pjt0105m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {
                ...initialState
                , belongDcdList: state.belongDcdList
                , postCdList: state.postCdList
            });
        },
        setExtUserData: (state, action: PayloadAction<IExtUserItemState>) => {
            state.extUserData = action.payload;
        },
        setExtUserList: (state, action: PayloadAction<IExtUserListItemState[]>) => {
            state.extUserList = action.payload;
        },
        setBelongDcdList: (state, action: PayloadAction<IBelongDcdState[]>) => {
            state.belongDcdList = action.payload;
        },
        setPostCdList: (state, action: PayloadAction<IPostCdState[]>) => {
            state.postCdList = action.payload;
        },
        setInquiryCnds: (state, action: PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action: PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default pjt0105m_Slice.reducer;
export const Pjt0105mAction = pjt0105m_Slice.actions;
export const Pjt0105mReducer = pjt0105m_Slice.reducer;